import getImageSize from './getImageSize';
import { MIN_HEIGHT, MIN_WIDTH } from '../constants';
import { MultiImageFileError } from '../types';

export const cleanFileName = (fileName: string): string => {
  const invalidCharsRegex = /[^A-Za-z0-9._\-]/g;
  return fileName.replace(invalidCharsRegex, '_');
};

type FileDropResult = 'success' | 'partial-success' | 'error';

const getFileDropResult = (validFiles: File[], fileErrors: MultiImageFileError[]): FileDropResult => {
  if (fileErrors.length === 0) {
    return 'success';
  }
  if (validFiles.length === 0) {
    return 'error';
  }
  return 'partial-success';
};

export const validateDroppedFiles = async (
  files: File[],
): Promise<{ fileDropResult: FileDropResult; validFiles: File[]; fileErrors: MultiImageFileError[] }> => {
  const validFileNames: string[] = [];
  const fileErrors: MultiImageFileError[] = [];

  await Promise.all(
    files.map(async file => {
      try {
        const imageSize = await getImageSize(file);
        if (imageSize.width < MIN_WIDTH || imageSize.height < MIN_HEIGHT) {
          fileErrors.push({ fileName: file.name, type: 'error-image-too-small' });
        } else {
          validFileNames.push(file.name);
        }
      } catch (_) {
        fileErrors.push({ fileName: file.name, type: 'error-unknown' });
      }
    }),
  );
  const validFiles = files.filter(file => validFileNames.includes(file.name));
  const fileDropResult = getFileDropResult(validFiles, fileErrors);

  return {
    fileDropResult,
    validFiles,
    fileErrors,
  };
};

export const getNextPossibleUploadIndex = (index: number, total: number) => Math.max(0, Math.min(total, index));
